"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _HBButton = require("./HBButton.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBButton2 = require("./HBButton.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var buttonSizeToLoaderSize = {
  xs: 'xs',
  sm: 'xs',
  md: 'small',
  lg: 'small',
  xl: 'small'
};
var HBButton = function HBButton(_ref) {
  var id = _ref.id,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    testIdType = _ref.testIdType,
    _ref$buttonTheme = _ref.buttonTheme,
    buttonTheme = _ref$buttonTheme === void 0 ? 'primary' : _ref$buttonTheme,
    customTheme = _ref.customTheme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? 'system' : _ref$scope,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'start' : _ref$iconPosition,
    _ref$shouldUseIconDef = _ref.shouldUseIconDefaultFill,
    shouldUseIconDefaultFill = _ref$shouldUseIconDef === void 0 ? false : _ref$shouldUseIconDef,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    children = _ref.children,
    onClick = _ref.onClick,
    href = _ref.href,
    target = _ref.target,
    className = _ref.className,
    _ref$loaderColor = _ref.loaderColor,
    loaderColor = _ref$loaderColor === void 0 ? _colors["default"].neutral900 : _ref$loaderColor,
    textTransform = _ref.textTransform,
    tabIndex = _ref.tabIndex,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? '0' : _ref$margin;
  // Element swapping: use anchor if href provided, button otherwise
  var isAnchor = Boolean(href);
  var baseProps = {
    id: id,
    disabled: disabled || loading,
    tabIndex: tabIndex,
    fullWidth: fullWidth,
    size: size,
    scope: scope,
    className: className,
    textTransform: textTransform
  };

  // Add element-specific props
  var elementSpecificProps = isAnchor ? {
    href: disabled ? undefined : href,
    target: target,
    onClick: onClick
  } : {
    type: type,
    onClick: onClick
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'button',
    componentName: 'HBButton',
    testIdType: testIdType,
    enforce: false
  });
  var wrappedChildren = (0, _HBButton2.recursivelyWrapStringChildrenWithSpans)(children);
  var loaderSize = buttonSizeToLoaderSize[size];

  // Common props for both button and anchor
  var commonProps = _objectSpread(_objectSpread({}, baseProps), {}, {
    'data-testid': finalTestId,
    'data-testidtype': testIdType,
    theme: buttonTheme,
    customTheme: customTheme,
    $margin: margin,
    $shouldUseIconDefaultFill: shouldUseIconDefaultFill
  });
  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loading && /*#__PURE__*/_react["default"].createElement(_HBButton.Loader, {
    size: loaderSize,
    color: loaderColor
  }), icon && /*#__PURE__*/_react["default"].createElement(_HBButton.IconWrapper, {
    iconPosition: iconPosition,
    size: size
  }, icon), wrappedChildren);
  if (isAnchor) {
    return /*#__PURE__*/_react["default"].createElement(_HBButton.Anchor, (0, _extends2["default"])({}, commonProps, elementSpecificProps), content);
  }
  var ButtonComp = customTheme ? _HBButton.CustomButton : _HBButton.Button;
  return /*#__PURE__*/_react["default"].createElement(ButtonComp, (0, _extends2["default"])({}, commonProps, elementSpecificProps), content);
};
var _default = exports["default"] = HBButton;
//# sourceMappingURL=HBButton.js.map